import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-qr-progress-bar',
  templateUrl: './qr-progress-bar.component.html',
  styleUrls: ['./qr-progress-bar.component.css']
})
export class QrProgressBarComponent {
  @Input() label: string = 'Tiến độ';
  @Input() current: number = 0;
  @Input() total: number = 0;
  @Input() isOver: boolean = false;

  get progressPercent(): number {
    if (this.total === 0) return 0;
    const percent = (this.current / this.total) * 100;
    return percent > 100 ? 100 : percent;
  }

  get progressBackground(): string {
    if (this.isOver) return 'linear-gradient(90deg, #ef4444 0%, #dc2626 100%)';
    if (this.progressPercent === 100) return 'linear-gradient(90deg, #10b981 0%, #059669 100%)';
    return 'linear-gradient(90deg, #3b82f6 0%, #2563eb 100%)';
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/ui/qr-progress-bar/qr-progress-bar.component.ts